import { Observable } from "rxjs/Rx";
import * as toastr from "toastr";

export abstract class BaseService {
  constructor() {}

  protected handleError(error: any) {
    console.log(error);

    var applicationError = error.headers.get("Application-Error");

    // either applicationError in header or model error in body
    if (applicationError) {
      return Observable.throw(applicationError);
    }

    var modelStateErrors: string = "";
    var serverError = error.json();

    if (!serverError.type) {
      for (var key in serverError) {
        if (serverError[key]) modelStateErrors += serverError[key] + "\n";
      }
    }

    modelStateErrors = modelStateErrors = "" ? null : modelStateErrors;

    if (modelStateErrors.indexOf("The user is not authenticated.") >= 0) {
      toastr.error("Usuário desconectado, por favor logue-se novamente.");

      setTimeout(() => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user_logado");

        window.location.href = "/login";
      }, 3000);
    }

    return Observable.throw(modelStateErrors || "Server error");
  }
}
